export enum CryptoCurrencyEnum {
  Eth = "ETH",
}
